export default ".overlayWhite {\n  display: none !important;\n}\n"